import React from 'react';

import { BaseModal } from 'components';

import { IFullScreenChartModalProps } from './FullScreenChartModal.types';

import './FullScreenChartModal.styles.scss';

const FullScreenChartModal = ({ open, children, ...props }: IFullScreenChartModalProps) => {
  return (
    <BaseModal fullScreen open={open} className="np-full-screen-chart-modal" {...props}>
      {children}
    </BaseModal>
  );
};

export default FullScreenChartModal;
